import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {useParams} from "react-router-dom";
import {useArticle} from "../api/articleapi";
import {Button, Col} from "react-bootstrap";
import {minioBaseUrl} from "../data/defaultConfig";

export function ArticleViewPage(props) {
    const {id} = useParams();
    const {article} = useArticle(id);
    return <BasePageLayout>
        <Col xs={12} className={'text-center'}>
            <h4>{article?.title}</h4>
        </Col>
        <div className={'mt-2'} dangerouslySetInnerHTML={{__html: article?.description}}>

        </div>
        {article?.filesarticles?.length > 0 ?
            <div>
                <Button href={`${minioBaseUrl}${article.filesarticles[0].url}`} target={'_blank'}>Download
                    bijlage</Button>
            </div>
            :
            ""
        }
    </BasePageLayout>


}